export const config = {
    faqUrl: 'https://support.modernhealth.com/hc/en-us',
    claimsMail: 'claims@modernhealth.com',
};
